import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Mail, FlaskConical } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="relative w-12 h-12">
                <div className="absolute inset-0 bg-amber-500/30 rounded-xl blur-md"></div>
                <div className="relative w-12 h-12 bg-gradient-to-br from-amber-400 via-amber-500 to-amber-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-500/25 border border-amber-400/30">
                  <span className="text-black font-black text-xl tracking-tighter">FS</span>
                </div>
              </div>
              <div className="flex flex-col">
                <span className="text-white font-black text-xl tracking-tight leading-none">FORGED</span>
                <span className="text-amber-500 font-semibold text-xs tracking-widest">SUPPS</span>
              </div>
            </Link>
            <p className="text-zinc-400 mb-4 max-w-md">
              Premium research chemicals and reference standards for qualified researchers. Lab tested, discreet UK delivery.
            </p>
            <div className="flex gap-3">
              <a
                href="https://wa.me/447440352811"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white p-2.5 rounded-full transition-colors"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
              <a
                href="mailto:support@forgedsupps.com"
                className="bg-zinc-800 hover:bg-zinc-700 text-white p-2.5 rounded-full transition-colors"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products?category=peptides" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  Peptides
                </Link>
              </li>
              <li>
                <Link to="/products?category=injectable-oils" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  Injectable Oils
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-zinc-400 hover:text-amber-500 transition-colors">
                  Disclaimer
                </Link>
              </li>
              <li className="text-zinc-400">UK 1-2 Day Delivery</li>
              <li className="text-zinc-400">Lab Tested Products</li>
            </ul>
          </div>
        </div>

        {/* Research Disclaimer */}
        <div className="border-t border-zinc-800 mt-8 pt-6">
          <div className="flex items-start gap-3 bg-zinc-900/50 rounded-xl p-4 border border-zinc-800 mb-6">
            <FlaskConical className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
            <p className="text-zinc-500 text-xs leading-relaxed">
              <span className="text-zinc-400 font-semibold">Disclaimer:</span> All products sold on this website are intended strictly for in-vitro laboratory and research purposes only. They are not intended for human or animal consumption, and are not sold as food supplements, drugs, or medicines. No products have been evaluated by the MHRA, FDA, or any regulatory body. The buyer assumes full responsibility for the lawful use of all products purchased. You must be 18 or older to use this website. By using this site you agree to our{' '}
              <Link to="/terms" className="text-amber-500 hover:underline">Terms &amp; Conditions</Link>.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-zinc-500 text-sm">
              © {new Date().getFullYear()} Forged Supps. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-zinc-500">
              <span>Research purposes only</span>
              <span>•</span>
              <span>18+ only</span>
              <span>•</span>
              <span>UK Based</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
